import { ActivatedRoute } from '@angular/router';

import { Command } from '../../coaching-base/command/command';
import { GoalStatus } from '../../coaching-base/general';
import { epicDependencies } from '../../store';
import { GoalsCollection } from '../goals-collection.model';

/* TODO rename */
export function overrideGoals(goals: GoalsCollection): void {
    try {
        // TODO FIXME. this can be done better
        const service =
            epicDependencies.injector.get<ActivatedRoute>(
                ActivatedRoute,
            ).snapshot;

        const commandB64 = service.queryParamMap.get('coachingCommand');
        const params = new URLSearchParams(atob(commandB64));
        const commandStr = params.get('command');

        switch (commandStr.toLowerCase()) {
            /* TODO auto-focus */
            case Command.UPDATE_GOAL.toLowerCase():
                updateGoal(params, goals);
                break;
        }
    } catch {}
}

function updateGoal(params: URLSearchParams, goals: GoalsCollection): void {
    const goalId = parseInt(params.get('goalId'));
    const goalValue = parseInt(params.get('goalValue'));
    const estimatedCompletionDate = new Date(
        params.get('estimatedCompletionDate'),
    );

    const index = goals.commitmentKpis.findIndex((goal) => {
        return goal.statusId === GoalStatus.ACTIVE && goal.goalId === goalId;
    });
    if (index === -1) {
        return;
    }

    const og = goals.commitmentKpis[index];
    goals.commitmentKpis.splice(index, 0, {
        ...og,
        goalValue: goalValue ?? og.goalValue,
        estimatedCompletionDate:
            estimatedCompletionDate ?? og.estimatedCompletionDate,
        isOriginalGoal: undefined,
        tracking_id: Math.random(),
    });
}
